var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoinRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "url(#paint0_linear_7203_92906)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8267C9.10457 11.8267 10 10.1134 10 8.00001C10 5.8866 9.10457 4.17334 8 4.17334C6.89543 4.17334 6 5.8866 6 8.00001C6 10.1134 6.89543 11.8267 8 11.8267Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 7.99992C11.0001 8.64659 10.8467 10.7733 8.98008 12.3333C9.50008 12.5399 10.0667 12.6666 10.6667 12.6666C13.2401 12.6666 15.3334 10.5733 15.3334 7.99992C15.3334 5.42659 13.2401 3.33325 10.6667 3.33325C10.0667 3.33325 9.50008 3.45992 8.98008 3.66659C10.8467 5.22659 11.0001 7.35325 11.0001 7.99992ZM5.33342 12.6666C5.93341 12.6666 6.50008 12.5399 7.02008 12.3333C6.61341 11.9933 6.28675 11.6199 6.02675 11.2466C5.80675 11.2999 5.57341 11.3333 5.33342 11.3333C3.49341 11.3333 2.00008 9.83992 2.00008 7.99992C2.00008 6.15992 3.49341 4.66659 5.33342 4.66659C5.57341 4.66659 5.80675 4.69992 6.02675 4.75325C6.28675 4.37992 6.61341 4.00659 7.02008 3.66659C6.50008 3.45992 5.93341 3.33325 5.33342 3.33325C2.76008 3.33325 0.666748 5.42659 0.666748 7.99992C0.666748 10.5733 2.76008 12.6666 5.33342 12.6666Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7203_92906",
    x1: 7.99933,
    y1: 4.17187,
    x2: 7.99933,
    y2: 11.8252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7203_92906",
    x1: 7.99868,
    y1: 3.33594,
    x2: 7.99868,
    y2: 12.6693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinRight);
export default __webpack_public_path__ + "static/media/join_right.9ee6d1e9d18953fa5f2a30f755099eaa.svg";
export { ForwardRef as ReactComponent };